import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./VerifyOTP.css";
import PopupMessage from "../PopupMessage/PopupMessage";
import { adminVerifyOtp, adminResendOtp } from "../Apis/AdminApis";
import logo1 from "../images/LargeTile.scale-150.png";
import logo2 from "../images/LargeTile.scale-150.png";
import logo3 from "../images/LargeTile.scale-150.png";
import logo4 from "../images/LargeTile.scale-150.png";
import logo5 from "../images/LargeTile.scale-150.png";
import logo6 from "../images/LargeTile.scale-150.png";

const VerifyOTP = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [loading, setLoading] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("info");
  const [timeLeft, setTimeLeft] = useState(120); 
  useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s.toString().padStart(2, "0")}`;
  };

  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "");

    if (value.length > 1) {
      const digits = value.slice(0, 6).split("");
      const updatedOtp = [...otp];

      digits.forEach((digit, i) => {
        if (index + i < 6) {
          updatedOtp[index + i] = digit;
        }
      });

      setOtp(updatedOtp);

      const focusIndex = Math.min(index + digits.length, 5);
      document.getElementById(`otp-${focusIndex}`)?.focus();
      return;
    }

    if (!/^[0-9]?$/.test(value)) return;

    const updatedOtp = [...otp];
    updatedOtp[index] = value;
    setOtp(updatedOtp);
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const updatedOtp = [...otp];

      if (updatedOtp[index]) {
        updatedOtp[index] = "";
        setOtp(updatedOtp);
      } else if (index > 0) {
        updatedOtp[index - 1] = "";
        setOtp(updatedOtp);
        document.getElementById(`otp-${index - 1}`)?.focus();
      }
    }

    if (e.key === "ArrowLeft" && index > 0) {
      document.getElementById(`otp-${index - 1}`)?.focus();
    }

    if (e.key === "ArrowRight" && index < 5) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

const handleVerify = async () => {
  const otpValue = otp.join("");
  const email = sessionStorage.getItem("adminEmail");

  if (!email) {
    setPopupMessage("Session expired. Please login again.");
    setPopupType("error");
    setPopupOpen(true);
    return;
  }

  if (otpValue.length !== 6) return;

  setLoading(true);

  const payload = {
    action: "login_verify",
    email: email,
    otp: otpValue,
  };

  const response = await adminVerifyOtp(payload);
  setLoading(false);

  if (response.error || !response.user_id) {
    setPopupMessage(response.error || "OTP verification failed");
    setPopupType("error");
    setPopupOpen(true);
    return;
  }

  setPopupMessage(response.message);
  setPopupType("success");
  setPopupOpen(true);
  const sessionData = {
  user_id: response.user_id,
  role: response.role,
  name: response.name,
  email: response.email,
   is_dgca_company: response.is_dgca_company === true
};

sessionStorage.setItem("session_data", JSON.stringify(sessionData));
sessionStorage.setItem("adminRole", response.role);
sessionStorage.setItem("adminUserId", response.user_id);  
localStorage.setItem("admin_logo", response.logo_url || "");
  localStorage.setItem("company_name", response.company_name || "");

setTimeout(() => {
  navigate(
    response.role === "superadmin"
      ? "/superadmin/dashboard"
      : "/admin/dashboard"
  );
}, 500);
};


const handleResendOtp = async () => {
  if (timeLeft > 0) return;

  const email = sessionStorage.getItem("adminEmail");

  if (!email) {
    setPopupMessage("Session expired. Please login again.");
    setPopupType("error");
    setPopupOpen(true);
    return;
  }

  const payload = {
    action: "login_otp",
    email: email,
    otp_send_type: sessionStorage.getItem("otpSendType"),
  };

  setLoading(true);
  const response = await adminResendOtp(payload);
  setLoading(false);

  if (response.error) {
    setPopupMessage(response.error || "Failed to resend OTP");
    setPopupType("error");
    setPopupOpen(true);
    return;
  }

  setPopupMessage(response.message);
  setPopupType("success");
  setPopupOpen(true);

  setTimeLeft(120);
  setOtp(["", "", "", "", "", ""]);
  document.getElementById("otp-0")?.focus();
};

  const isVerifyEnabled = otp.every(d => d !== "") && timeLeft > 0;

  return (
    <div className="login-wrapper">
      <PopupMessage
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
        type={popupType}
      />

      <div className="logo-background">
        <img src={logo1} className="small-logo logo1" alt="" />
        <img src={logo2} className="small-logo logo2" alt="" />
        <img src={logo3} className="small-logo logo3" alt="" />
        <img src={logo4} className="small-logo logo4" alt="" />
        <img src={logo5} className="small-logo logo5" alt="" />
        <img src={logo6} className="small-logo logo6" alt="" />
      </div>

      <div className="otp-overlay">
        <div className="otp-card">
          <h2 className="otp-title">Verify OTP</h2>

          <p className="otp-subtitle">
            Enter the 6-digit verification code sent to{" "}
            {sessionStorage.getItem("otpSendType") === "mobile"
              ? `+******${(sessionStorage.getItem("adminMobile") || "").slice(-4)}`
              : (() => {
                  const email = sessionStorage.getItem("adminEmail") || "";
                  if (!email.includes("@")) return "";
                  const [name, domain] = email.split("@");
                  return `${name[0]}***${name[name.length - 1]}@${domain}`;
                })()}
          </p>

          <div className="otp-inputs">
            {otp.map((digit, index) => (
              <input
                key={index}
                id={`otp-${index}`}
                maxLength="1"
                value={digit}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onPaste={(e) => {
                  e.preventDefault();
                  const pasteData = e.clipboardData.getData("text").replace(/\D/g, "");
                  if (pasteData.length === 6) handleChange({ target: { value: pasteData } }, 0);
                }}
              />
            ))}
          </div>

          <div className="otp-info">
            <span className="otp-timer">⏱ {formatTime(timeLeft)}</span>
            <span
  className="otp-resend"
  onClick={handleResendOtp}
  style={{
    cursor: timeLeft <= 0 ? "pointer" : "not-allowed",
    opacity: timeLeft <= 0 ? 1 : 0.5,
  }}
>
  Resend OTP
</span>
          </div>

          <div className="otp-actions">
            <button className="btn-back" onClick={() => navigate(-1)}>
              Back
            </button>

            <button
              className="btn-verify"
              onClick={handleVerify}
              disabled={!isVerifyEnabled || loading}
            >
              {loading ? "Verifying..." : "Verify"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyOTP;
